import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import * as Actions from "../../actions/actions";
import Counter from "../common/Counter";
import numeral from "numeral";
import Tag from "./Tag";
import Input from "../common/Input";
import InputBlock from "../common/InputBlock";
import CheckBox from "../common/CheckBox";
import CartColumn from "./CartColumn";
import CartRow from "./CartRow";

const Table = styled.table`
  width: 100%;
  td{
    padding-top: 10px;
    padding-bottom: 10px;
  }
  tr{
    border-bottom: 1px solid ${p => p.theme.cBorderLight};
    &:last-child{
      border-bottom: none;
    }
  }
  .numbers{
    width: 120px;
    text-align: right;
  }
  .price{
    font-weight: bold;
  }
  .delivery, .last{
    border-bottom: 1px solid ${p => p.theme.cBorder};
  }
`;

class CartPage extends Component {

    getProduct = (id) => {
        return this.props.products.filter((item) => item.id === id)[0];
    };

    getTotal = () => {
        let total = 0;
        const items = this.props.items;
        for(let i = 0; i < items.length; i++) {
            total += this.getProduct(items[i].product_id).price * items[i].quantity;
        }
        return numeral(total).format('0.00') + ' €';
    };

    render() {

        const items = this.props.items.map((item, key) => {
            const product = this.getProduct(item.product_id);
            return <tr key={key} className={`${(key === (this.props.items.length -1)) ? 'last' : ''}`}>
                <td>{product.size.x + '×' + product.size.y + ' mm'}</td>
                <td className={'numbers'}>{item.quantity + ' шт.'}</td>
                <td className={'numbers price'}>{numeral(product.price * item.quantity).format('0.00') + ' €'}</td>
            </tr>
        });

        return (
            <React.Fragment>
                <CartRow>
                    <div className="col">
                        <CartColumn title={'Сводка'}>
                            <Table>
                                <tbody>
                                    {items}
                                    <tr className={'delivery'}>
                                        <td colSpan={2}>Доставка</td>
                                        <td className={'numbers price'}>25 €</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Общая стоимость</td>
                                        <td className={'numbers price'}>{this.getTotal()}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </CartColumn>
                    </div>
                </CartRow>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        items: state.getIn(['cart', 'items']),
        products: state.get('products'),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        cartChangeDeliveryInfo: Actions.cartChangeDeliveryInfo,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(CartPage));